import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { ImpactRecord, getYoutubeId } from '@/hooks/useImpactRecords';

interface Props {
  testimonial: ImpactRecord | null;
  onClose: () => void;
}

export default function TestimonialVideoModal({ testimonial, onClose }: Props) {
  const open = !!testimonial;
  const ytId = testimonial ? getYoutubeId(testimonial.video_url) : null;
  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-3xl">
        <DialogHeader>
          <DialogTitle>{testimonial?.title}</DialogTitle>
          {testimonial?.subtitle && (
            <p className="text-sm text-muted-foreground">{testimonial.subtitle}</p>
          )}
        </DialogHeader>
        {ytId ? (
          <div className="aspect-video w-full overflow-hidden rounded-lg bg-black">
            <iframe
              src={`https://www.youtube.com/embed/${ytId}?autoplay=1&rel=0`}
              title={testimonial?.title ?? 'Testimonio'}
              className="w-full h-full"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          </div>
        ) : (
          <p className="text-sm text-muted-foreground">Video no disponible.</p>
        )}
      </DialogContent>
    </Dialog>
  );
}
